
import { BlogCard } from "./BlogCard";
import { BlogPost } from "@/types/blog";
import { Skeleton } from "@/components/ui/skeleton";

interface RelatedPostsProps {
  posts: BlogPost[];
  currentPostId?: number | string; // Updated to accept both types
  loading?: boolean;
}

export function RelatedPosts({ posts, currentPostId, loading = false }: RelatedPostsProps) {
  // Filter out the current post and limit to max 3 posts
  const filteredPosts = posts
    .filter(post => currentPostId === undefined || post.id !== Number(currentPostId)) // Ensure consistent comparison
    .slice(0, 3);
  
  if (filteredPosts.length === 0 && !loading) {
    return null;
  }

  return (
    <section className="mt-10 pt-8 border-t">
      <h2 className="text-2xl font-bold mb-6">Articoli correlati</h2>
      
      {loading ? (
        // Loading state
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[1, 2, 3].map(i => (
            <div key={i} className="flex flex-col gap-2">
              <Skeleton className="h-40 w-full" />
              <Skeleton className="h-4 w-3/4" />
              <Skeleton className="h-6 w-full" />
              <Skeleton className="h-4 w-5/6" />
            </div>
          ))}
        </div>
      ) : (
        // Loaded content
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredPosts.map(post => (
            <BlogCard
              key={post.id}
              post={post}
              compact
            />
          ))}
        </div>
      )}
    </section>
  );
}
